import React from 'react';
import { Title, Icon, Text, Tooltip } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { ContactDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import FeedbackAgents from './FeedbackAgents';
import FeedbackMessageEditor, {
  FeedbackMessageEditorProps,
} from './FeedbackMessageEditor';

type Contact = JsonObject<ContactDoc>;

export type FeedbackRequestProps = {
  contacts: Contact[];
  updateContacts: (contact: Contact) => void;
  setIsCustomSelected: () => void;
} & FeedbackMessageEditorProps;

const FeedbackRequest: React.FC<FeedbackRequestProps> = ({
  contacts,
  updateContacts,
  ...feedbackMessageProps
}) => {
  const { lg } = useBreakpoint();

  return (
    <StyledContainer $lg={lg}>
      <div>
        <Title level={3} data-cy="feedback-request-title">
          Feedback Request Template
          <Tooltip
            overlayStyle={lg ? { maxWidth: '550px' } : undefined}
            placement="right"
            title={
              <Text color="white" data-cy="feedback-request-info-text">
                This page gives you the ability to assign an existing email
                template or create a custom email for this listing. Create a
                custom template by clicking on the{' '}
                <Text strong color="white">
                  Use Template
                </Text>{' '}
                dropdown and scroll to the bottom!
              </Text>
            }
          >
            <Text>
              <Icon
                type="antdInfoCircleFilled"
                color="gray8"
                offset={[5, -5]}
                data-cy="feedback-request-info-icon"
              />
            </Text>
          </Tooltip>
        </Title>

        <FeedbackMessageEditor {...feedbackMessageProps} />
      </div>
      <div>
        <Title level={3} type="secondary" data-cy="notification-settings-title">
          Notification Settings
        </Title>
        <Text type="secondary" data-cy="notification-settings-subtitle">
          Notify the following listing contacts when feedback is received on
          this listing.
        </Text>
        <FeedbackAgents
          contacts={contacts}
          updateContacts={updateContacts}
          data-cy="notification-setting-list"
        />
      </div>
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $lg: boolean }>`
  ${({ $lg }) =>
    $lg &&
    `
      display: grid;
      grid-template-columns: 2fr 1fr;
      grid-column-gap: 30px;
    `}
`;

export default FeedbackRequest;
